import './style/index.less';
import ExternalMessage from './ExternalMessage';
export type { CorpUnreadMessage } from './ExternalMessage';

export default ExternalMessage;
